import axios from "axios";

export default {
  state: {
    types: []
  },

  mutations: {
    SET_PUBLICATION_TYPES(state, value) {
      state.types = value;
    }
  },

  actions: {
    loadPublicationTypes({ commit }) {
      axios.get("/admin/api/publication-types").then(response => {
        commit("SET_PUBLICATION_TYPES", response.data.data);
      });
    }
  }
};
